import React, { FC, MutableRefObject } from 'react'
import clsx from 'clsx'
import { scrollInView } from '@dxp-module/common'
import { Box, Typography } from '@mui/material'
import scrollToTargetStyles from './scrollToTargetButton.styles'

type ScrollToTargetButton = {
  value: number | string | JSX.Element
  targetRef: MutableRefObject<undefined | HTMLElement>
  className?: string
}

const ScrollToTargetButton: FC<ScrollToTargetButton> = ({
  value,
  targetRef,
  className,
}) => {
  const styles = scrollToTargetStyles()
  const scrollToDisclaimer = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation()
    targetRef.current && scrollInView.scrollInView(targetRef?.current)
  }

  return (
    <Box
      onClick={scrollToDisclaimer}
      className={clsx([styles.container, className])}
      data-test={`common:scroll-to-${value}`}
    >
      <Typography
        component="span"
        className={styles.labelText}
        variant="caption"
      >
        {value}
      </Typography>
    </Box>
  )
}

export default ScrollToTargetButton
